import DataSourceContainer from "../../Componant/DataTable/DataSource";

const DataSource = () => {
  return (
    <div className="page-body">
      <DataSourceContainer />
    </div>
  );
};

export default DataSource;
